import React, { useState } from 'react';
import { OnboardingDraft } from './types';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
import { Callout } from '../../ui/Callout';
import { ImageUpload } from '../ImageUpload';
interface StepProfileProps {
  data: Partial<OnboardingDraft>;
  updateData: (data: Partial<OnboardingDraft>) => void;
  onSubmit: () => void;
}
export function StepProfile({
  data,
  updateData,
  onSubmit
}: StepProfileProps) {
  const [name, setName] = useState(data.profile?.name || '');
  const [phone, setPhone] = useState(data.profile?.phone || '');
  const [avatar, setAvatar] = useState(data.profile?.avatar || '');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name) {
      updateData({
        profile: {
          name,
          phone,
          avatar
        }
      });
      onSubmit();
    }
  };
  return <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500 max-w-md mx-auto" data-id="element-1720">
      <div className="text-center" data-id="element-1721">
        <h2 className="text-2xl font-bold text-light-1" data-id="element-1722">Aproape gata!</h2>
        <p className="text-light-3 mt-2" data-id="element-1723">
          Ultimele detalii pentru profilul tău.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1724">
        <div className="space-y-3" data-id="element-1725">
          <Callout variant="tip" dismissible dismissKey="profile-photo-importance" title="O poză de profil dublează șansele să primești oferte." data-id="element-1726">
            Proprietarii vor să vadă cu cine vorbesc — alege o poză clară,
            prietenoasă, doar tu în cadru.
          </Callout>
          <ImageUpload value={avatar} onChange={setAvatar} showCameraOption data-id="element-1727" />
        </div>

        <div className="space-y-4" data-id="element-1728">
          <div className="space-y-1.5" data-id="element-1729">
            <label className="block text-sm font-medium text-light-2" data-id="element-1730">
              Nume complet *
            </label>
            <Input value={name} onChange={e => setName(e.target.value)} placeholder="ex: Andrei Popescu" className="bg-dark-2 border-dark-3" required data-id="element-1731" />
          </div>

          <div className="space-y-1.5" data-id="element-1732">
            <label className="block text-sm font-medium text-light-2" data-id="element-1733">
              Telefon (opțional)
            </label>
            <Input type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="ex: 0722 123 456" className="bg-dark-2 border-dark-3" data-id="element-1734" />
            <p className="text-xs text-light-3" data-id="element-1735">
              Pentru contact direct cu proprietarii.
            </p>
          </div>
        </div>

        <Button type="submit" className="w-full h-12 bg-lime-1 text-dark-1 hover:bg-lime-2 font-semibold text-base" data-id="element-1736">
          Finalizează
        </Button>
      </form>
    </div>;
}